<!--
 * @Author: your name
 * @Date: 2019-11-18 17:26:49
 * @LastEditTime: 2020-06-01 16:16:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\navbar\UCFormUserVerification.vue
 -->
<!--  -->

<template>
  <el-dialog
    :visible.sync="ucFormSet.formVisible"
    title="系统登录"
    class="dialogTheme"
    style="text-align: left"
    width="300px"
    :modal-append-to-body='false'
  >
    <el-form
      v-model="user"
    >
      
      <el-form-item >
        <el-input v-model="user.username" placeholder="请输入用户名"></el-input>
      </el-form-item>

      <el-form-item >
        <el-input v-model="user.password" placeholder="请输入密码" show-password></el-input>
      </el-form-item>

      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="_verify">登录</el-button>
        <!-- <el-button @click="_reset">重置</el-button> -->
      </el-form-item>

    </el-form>
  </el-dialog>
</template>

<script>
import { TdtUser } from "../model/TdtUserJs";
import { ServiceUrlConfig } from '../../../config/ServiceUrlConfigJs';
import { UCFormUserVerifyEvent } from './UCNavBarJs';
export default {
  name: "UCFormUserVerify",
  data() {
    return {
      //uc界面控制设置
      ucFormSet: {
        //form窗口的显隐
        formVisible: false,
      },

      user: new TdtUser(),
      
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {

    init()
    {
        this.user=new TdtUser();
        
    },

    /**
     * 显示form窗体
     */
    showForm() {
      this.ucFormSet.formVisible = true;
    },

    /**
     * 隐藏form窗体
     */
    hideForm() {
      this.ucFormSet.formVisible = false;
    },

    on_verifySucceed(callback)
    {
        if(callback)
        {
          this.$on(UCFormUserVerifyEvent.UCFormUserVerify_event_verifySucceed,callback);
        }
    },
    
    off_verifySucceed(callback)
    {
      if(callback)
        {
          this.$off(UCFormUserVerifyEvent.UCFormUserVerify_event_verifySucceed,callback);
        }
    },

    _reset()
    { 
      this.user=new TdtUser();
    },
    
    _verify() {
      
      let self=this;
      let verifyUrl=ServiceUrlConfig.userManagerSytem_user_login_government;
      this.user.verify(verifyUrl,
      function(response){
        if(response)
        { 
          self.user=TdtUser.fromJson(response);
          
          //验证通过
          self.$emit(UCFormUserVerifyEvent.UCFormUserVerify_event_verifySucceed,self.user);
          
          self.hideForm();

        }
        else
        {
          self.$message({
                  showClose: true,
                  type: "info",
                  message: "用户名或密码错误!"
                });
        }
        
      },
      
      function(error)
      { 

        
      });





    }


  }
};
</script>
<style >
</style>